module.exports = __webpack_public_path__ + "media/bench.e477fe57.wav";